import AvatarWithProgress from "./AvatarWithProgress";

export default AvatarWithProgress;
